/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Auth_Title4Inputs */

const en_svc_ai_app_rescue_auth_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth and payments`)
};

const ar_svc_ai_app_rescue_auth_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المصادقة والمدفوعات`)
};

const bn_svc_ai_app_rescue_auth_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অথ ও পেমেন্ট`)
};

const de_svc_ai_app_rescue_auth_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth und Zahlungen`)
};

const es_svc_ai_app_rescue_auth_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticación y pagos`)
};

const fr_svc_ai_app_rescue_auth_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification et paiements`)
};

const pt_svc_ai_app_rescue_auth_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autenticação e pagamentos`)
};

const zh_svc_ai_app_rescue_auth_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录与支付`)
};

const tr_svc_ai_app_rescue_auth_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kimlik doğrulama ve ödemeler`)
};

const ru_svc_ai_app_rescue_auth_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Авторизация и платежи`)
};

const pl_svc_ai_app_rescue_auth_title4 = /** @type {(inputs: Svc_Ai_App_Rescue_Auth_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logowanie i płatności`)
};

/**
* | output |
* | --- |
* | "Auth and payments" |
*
* @param {Svc_Ai_App_Rescue_Auth_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_auth_title4 = /** @type {((inputs?: Svc_Ai_App_Rescue_Auth_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Auth_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_auth_title4(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_auth_title4(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_auth_title4(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_auth_title4(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_auth_title4(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_auth_title4(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_auth_title4(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_auth_title4(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_auth_title4(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_auth_title4(inputs)
	return en_svc_ai_app_rescue_auth_title4(inputs)
});
export { svc_ai_app_rescue_auth_title4 as "svc_ai-app-rescue_AUTH_title" }